import React from 'react';

const Header = () => {
  return (
    <div className="top-header-bar">
      <div className="container-fluid px-3 px-xl-5">

        {/* Desktop Header */}
        <div className="d-none d-xl-flex align-items-center justify-content-between">

          <div className="topbar-contact-info">

            <span className="contact-item">
              <i className="bi bi-geo-alt-fill text-warning"></i>
               Vayusena Nagar, Nagpur
            </span>

            <a href="tel:7122511407" className="contact-item">
              <i className="bi bi-telephone-fill text-warning"></i>
             +91 71225 11407
            </a>

            <a
              href="mailto:bvmtrimurtinagar@gmail.com"
              className="contact-item"
            >
              <i className="bi bi-envelope-fill text-warning"></i>
              airforceschoolvsn@gmail.com
            </a>

          </div>

          <div className="topbar-portals-scroll">

            <a href="https://entab.online/BVMTRM" target="_blank" rel="noreferrer">
              <i className="bi bi-person-circle"></i>
              Parent Portal
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.entab.campuscare"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bi bi-phone"></i>
              Mobile App
            </a>

            <a
              href="https://portalguidelines.campuscare.info/index.html#BVMTRM"
              target="_blank"
              rel="noreferrer"
            >
              <i className="bi bi-question-circle"></i>
              Portal Help
            </a>

          </div>
        </div>

        {/* Mobile Header */}
        <div className="d-flex d-xl-none flex-column gap-2">

          <div className="topbar-mobile-contact">

            <a href="tel:07122230142">
              <i className="bi bi-telephone-fill text-warning"></i>
             91 91460 71487
            </a>

            <span>|</span>

            <a href="mailto:bvmtrimurtinagar@gmail.com">
              <i className="bi bi-envelope-fill text-warning"></i>
              Email Us
            </a>

          </div>

          <div className="topbar-portals-mobile-track">

            <a href="">
              Parent Portal
            </a>

            <a href="">
              Mobile App
            </a>

            <a href="">
              Portal Help
            </a>

          </div>

        </div>

      </div>
    </div>
  );
};

export default Header;